export type NativeEvent = typeof window.Event;
export type ClonableNativeEvent = (
	{
		prototype: {
			type: string;
			constructor: ClonableNativeEvent;
		};
		new(...args: ConstructorParameters<NativeEvent>): InstanceType<NativeEvent>;
	} &
	NativeEvent
	);

export function cloneNative<TEvent extends ClonableNativeEvent>(from: InstanceType<TEvent>): InstanceType<TEvent> {
	const Event = <ClonableNativeEvent>from.constructor;
	const clone = new Event(from.type, from);
	return (<InstanceType<TEvent>>clone);
}
